export default __webpack_public_path__ + "static/media/success-tick.adab877e.svg";